import glamorous from "glamorous";

export const Container = glamorous<{ colour?: string; height?: string }>("div")(
	props => ({
		width: "100%",
		height: props.height ? props.height : 220,
		display: "flex",
		flexDirection: "row",
		boxSizing: "border-box",
		// padding: 12,
		backgroundColor: props.colour ? props.colour : "green",
		border: "1px solid grey",
		// justifyContent: "center"
	})
);



// WEBPACK FOOTER //
// ./src/components/Piece/styles.tsx